import React, { forwardRef } from 'react';
import { StyledList } from './styled';
/**
 *
 * @property {keyof ReactHTML | ComponentType<any>} [component] - The HTML element or React component to be used as the root element. Defaults to 'ul'.
 * @property {JSX.Element | null} [subheader] - An optional JSX element to be rendered as a subheader.
 */
export const List = forwardRef(function List({ children, component = 'ul', subheader, ...props }, ref) {
    return (React.createElement(StyledList, { ref: ref, as: component, ...props },
        subheader,
        children));
});
